module.exports = __webpack_public_path__ + "static/media/41.ba45bf6a.png";